import React/*, { useState }*/ from 'react'

//import useSingleton from '../../../business-components/useSingleton/useSingleton'

//import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    formataPrimeiraReuniaoLinhaColuna,
    formataPrimeiraReuniaoLabelValor,
    formataPrimeriaReuniaoLinkManterReservaManterPadraoVida,
    formataPrimeiraReuniaoLinkManterReservaSemNovosAportes,
    formataPrimeiraReuniaoLinkConsumirReservaManterPadraoVida,
    formataPrimeiraReuniaoLinkConsumirReservaSemNovosAportes,
} from '../../../business-components/Formata/Formata'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem3xs6,
    GridItem3xs12,
    GridItem4,
    GridItem4xs12,
    GridItem4xs7,
    GridItem6,
    GridItem6sm12xs12,
    GridItem8,
    GridItem8xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorValor,
    TextValidatorNumber,
} from '../../../business-components/TextValidator/TextValidator'

import {
    SvgIconConsumirReserva,
    SvgIconPreservarReserva,
} from '../../../business-components/SvgIcon/SvgIconSimulacaoFinanceira/SvgIconSimulacaoFinanceira'

import {
    LinkPadraoNoSubmit,
} from '../../../business-components/Link/Link'

import {
    descricaoResumidaPergunta,
    valorPergunta,
} from '../form-form/FormServicePerguntas'

import {
    calculaJaAposentou,
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaRegistrosDefaultIniciaisHipotesesFinanceiras,
    setarAporteUnico,
} from './SimulacaoFinanceiraServiceHipotesesFinanceiras'

import {
    CustomizedDialogsPopupDiagnosticoAposentadoriaIndependenciaFinanceira,
    CustomizedDialogsPopupEvolucaoReservaFinanceira,
    CustomizedDialogsPopupComparacaoCenarios,
    CustomizedDialogsPopupComparacaoEstudos,
} from './SimulacaoFinanceiraCompHipotesesFinanceiras'

import SimulacaoFinanceiraFormAporteRetiradaMensal from './SimulacaoFinanceiraFormAporteRetiradaMensal'

import SimulacaoFinanceiraFormAporteRetiradaAnual from './SimulacaoFinanceiraFormAporteRetiradaAnual'




const SimulacaoFinanceiraFormHipotesesFinanceiras = ({ variaveisGlobais, values, handleChange, /*handleSubmit, */setFieldValue,
    handleSubmitAutomatico, estudo, vars, linhaFormList, popup }) => {

    //const [refresh, setRefresh] = useState(true)

    const jaAposentou = calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))

    const classNameTitulo = 'mt-4'

    const classNameLink = "mt-4 text-center"

    const GridItemHipotesesFinanceiras = popup ? GridItem12 : GridItem6sm12xs12

    const isXsDownScreen = IsXsDownScreen()

    //useSingleton(async () => {

        processaRegistrosDefaultIniciaisHipotesesFinanceiras(values)
    //})

    return (
        //(refresh || !refresh) && (
        <GridItemHipotesesFinanceiras>
            <CardGridEntradaDados>
                <CardGridEntradaDadosHeaderBody
                    title={LABEL.planejamentoAposentadoria}
                >
                    <GridContainer>
                        <GridItem6
                            align='center'
                        >
                            {formataPrimeiraReuniaoLinhaColuna(LABEL.retiradaReservaManterPadraoVidaDesejadoAposentadoria)}
                        </GridItem6>

                        {!jaAposentou && (
                                <GridItem6
                                align='center'
                            >
                                {formataPrimeiraReuniaoLinhaColuna(LABEL.aportesMensaisParaAtingirPadraoVidaDesejado)}
                            </GridItem6>
                        )}
                    </GridContainer>

                    <GridContainer>
                        <GridItem6>
                            <GridContainer
                                className='justify-center'
                            >
                                <GridItem4xs7>
                                    <TextValidatorValor
                                        name="retiradaMensalDepoisAposentarCliente"
                                        label={""}
                                        value={values.retiradaMensalDepoisAposentarCliente || ''}
                                        onChange={handleChange}
                                    />
                                </GridItem4xs7>
                            </GridContainer>
                            {/*
                            <TextValidatorValor
                                name="aporteMensalDepoisAposentarCliente"
                                label={LABEL.aporteMensal}
                                value={values.aporteMensalDepoisAposentarCliente || ''}
                                onChange={handleChange}
                            />
                            */}
                            
                        </GridItem6>

                        {!jaAposentou && (
                            <GridItem6>
                                <GridContainer
                                    className='justify-center'
                                >
                                    <GridItem4xs7>
                                        <TextValidatorValor
                                            name="aporteMensalAntesAposentarCliente"
                                            label={""}
                                            value={values.aporteMensalAntesAposentarCliente || ''}
                                            onChange={handleChange}
                                        />
                                    </GridItem4xs7>
                                </GridContainer>
                                {/*
                                <TextValidatorValor
                                    name="retiradaMensalAntesAposentarCliente"
                                    label={LABEL.retiradaMensal}
                                    value={values.retiradaMensalAntesAposentarCliente || ''}
                                    onChange={handleChange}
                                />
                                */}
                            </GridItem6>
                        )}
                    </GridContainer>
                </CardGridEntradaDadosHeaderBody>

                <CardGridEntradaDadosHeaderBody
                    title={LABEL.estrategiasPossiveis}
                >
                    <GridContainer
                        className='mt--4 mb--4'
                    >
                        <GridItem3
                            className={classNameTitulo}
                        />

                        {!isXsDownScreen && (
                            <GridItem1/>
                        )}

                        <GridItem4
                            className={classNameLink}
                        >
                            <GridContainer>
                                <GridItem3xs12
                                    className='mt--5'
                                    align='right'
                                >
                                    <SvgIconConsumirReserva
                                        style={{
                                            fontSize:'75px'
                                        }}
                                    />
                                </GridItem3xs12>

                                <GridItem8xs12
                                    align={isXsDownScreen ? 'right' : ''}
                                >
                                    {formataPrimeiraReuniaoLinhaColuna(
                                        LABEL.consumirReservaAte.replace("$1$", values.idadeFinalVitalicioClienteConjuge))
                                    }
                                </GridItem8xs12>
                            </GridContainer>
                        </GridItem4>

                        <GridItem4
                            className={classNameLink}
                        >
                            <GridContainer>
                                <GridItem4xs12
                                    className='mt--4'
                                    align='right'
                                >
                                    <SvgIconPreservarReserva
                                        style={{
                                            fontSize:'65px'
                                        }}
                                    />
                                </GridItem4xs12>

                                <GridItem8xs12
                                    align={isXsDownScreen ? 'right' : ''}
                                >
                                    {formataPrimeiraReuniaoLinhaColuna(LABEL.preservarReservaViverRentabilidade)}
                                </GridItem8xs12>
                            </GridContainer>
                        </GridItem4>
                    </GridContainer>

                    {!jaAposentou/* && values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal*/ && (
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            <GridItem4
                                className={classNameTitulo}
                            >
                                {formataPrimeiraReuniaoLinhaColuna(LABEL.aporteMensalAdicional)}
                            </GridItem4>

                            <GridItem3
                                className={classNameLink}
                            >
                                <LinkPadraoNoSubmit
                                    title={
                                        formataPrimeiraReuniaoLinkConsumirReservaManterPadraoVida(
                                            values.aporteMensalAdicionalConsumirReservaAposentadoria)
                                    }
                                    tooltip={LABEL.cliqueParaAdicionarAutomaticamenteAporteMensal}
                                    onClick={() => {
                                        values.aporteMensalAntesAposentarCliente =
                                            (values.aporteMensalAntesAposentarCliente 
                                                ?    
                                                    round(values.aporteMensalAntesAposentarCliente, 2)
                                                :
                                                    0
                                            ) + values.aporteMensalAdicionalConsumirReservaAposentadoria
                                    }}
                                />
                            </GridItem3>
                                
                            <GridItem1/>

                            <GridItem3
                                className={classNameLink}
                            >
                                <LinkPadraoNoSubmit
                                    title={
                                        formataPrimeriaReuniaoLinkManterReservaManterPadraoVida(
                                            values.aporteMensalAdicionalPreservarReservaAposentadoria)
                                    }
                                    tooltip={LABEL.cliqueParaAdicionarAutomaticamenteAporteMensal}
                                    onClick={() => {
                                        values.aporteMensalAntesAposentarCliente =
                                            (values.aporteMensalAntesAposentarCliente 
                                                ?    
                                                    round(values.aporteMensalAntesAposentarCliente, 2)
                                                :
                                                    0
                                            ) + values.aporteMensalAdicionalPreservarReservaAposentadoria
                                    }}
                                />
                            </GridItem3>
                        </GridContainer>
                    )}

                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && */!values.naoExibirOpcaoAporteUnico && (
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            <GridItem4
                                className={classNameTitulo}
                            >
                                {formataPrimeiraReuniaoLinhaColuna(LABEL.aporteUnicoAdicional)}
                            </GridItem4>

                            <GridItem3
                                className={classNameLink}
                            >
                                <LinkPadraoNoSubmit
                                    title={
                                        formataPrimeiraReuniaoLinkConsumirReservaManterPadraoVida(
                                            values.aporteUnicoAdicionalConsumirReservaAposentadoria)
                                    }
                                    tooltip={LABEL.cliqueParaAtribuirAutomaticamenteAporteUnico}
                                    onClick={() => {
                                        setarAporteUnico(values, values.aporteUnicoAdicionalConsumirReservaAposentadoria)
                                    }}
                                />
                            </GridItem3>
                                
                            <GridItem1/>

                            <GridItem3
                                className={classNameLink}
                            >
                                <LinkPadraoNoSubmit
                                    title={
                                        formataPrimeriaReuniaoLinkManterReservaManterPadraoVida(
                                            values.aporteUnicoAdicionalPreservarReservaAposentadoria)
                                    }
                                    tooltip={LABEL.cliqueParaAtribuirAutomaticamenteAporteUnico}
                                    onClick={() => {
                                        setarAporteUnico(values, values.aporteUnicoAdicionalPreservarReservaAposentadoria)
                                    }}
                                />
                            </GridItem3>
                        </GridContainer>
                    )}

                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal &&*/
                    (values.reservaInicioAposentadoriaPrimeiraReuniaoSituacaoIdeal !== 0 ||
                        values.reservaInicioAposentadoriaPrimeiraReuniaoViverRentabilidade !== 0
                    ) && (
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            <GridItem4
                                className={classNameTitulo}
                            >
                                {formataPrimeiraReuniaoLinhaColuna(
                                    LABEL.reservaInicioAposentadoriaComAportes.replace('$1$',
                                        jaAposentou ? values.idadeDataSimulacaoCliente : values.idadeVaiAposentarCliente))
                                }
                            </GridItem4>

                            <GridItem3
                                className={classNameLink}
                            >
                                {formataPrimeiraReuniaoLinkConsumirReservaManterPadraoVida(
                                    values.reservaInicioAposentadoriaPrimeiraReuniaoSituacaoIdeal)
                                }
                            </GridItem3>
                                
                            <GridItem1/>

                            <GridItem3
                                className={classNameLink}
                            >
                                {formataPrimeriaReuniaoLinkManterReservaManterPadraoVida(
                                    values.reservaInicioAposentadoriaPrimeiraReuniaoViverRentabilidade)
                                }
                            </GridItem3>
                        </GridContainer>
                    )}

                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && (*/}
                    <GridContainer>
                        {!isXsDownScreen && (
                            <GridItem1/>
                        )}

                        <GridItem4
                            className={classNameTitulo}
                        >
                            {formataPrimeiraReuniaoLinhaColuna(LABEL.retiradaMaximaSemNovosAportesAdicionais)}
                        </GridItem4>

                        <GridItem3
                            className={classNameLink}
                        >
                            <LinkPadraoNoSubmit
                                title={
                                    formataPrimeiraReuniaoLinkConsumirReservaSemNovosAportes(
                                        values.retiradaMensalMaximaConsumirReservaAposentadoria)
                                }
                                tooltip={LABEL.cliqueParaAtribuirAutomaticamenteRetiradaMensal}
                                onClick={() => {
                                    values.retiradaMensalDepoisAposentarCliente =
                                        values.retiradaMensalMaximaConsumirReservaAposentadoria
                                }}
                            />     
                        </GridItem3>

                        <GridItem1>
                            
                        </GridItem1>

                        <GridItem3
                            className={classNameLink}
                        >
                            <LinkPadraoNoSubmit
                                title={
                                    formataPrimeiraReuniaoLinkManterReservaSemNovosAportes(
                                        values.retiradaMensalMaximaPreservarReservaAposentadoria)
                                }
                                tooltip={LABEL.cliqueParaAtribuirAutomaticamenteRetiradaMensal}
                                onClick={() => {
                                    values.retiradaMensalDepoisAposentarCliente =
                                        values.retiradaMensalMaximaPreservarReservaAposentadoria
                                }}
                            />
                        </GridItem3>
                    </GridContainer>
                    {/*})}*/}

                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && (*/}
                    <GridContainer
                        className="mt-1"
                        align="center"
                    >
                        {
                            linhaFormList.idRendaFalta &&
                            valorPergunta(values, linhaFormList.idRendaFalta)
                                ?
                                    <GridItem12>
                                        <LinkPadraoNoSubmit
                                            title={
                                                formataPrimeiraReuniaoLabelValor(
                                                    descricaoResumidaPergunta(linhaFormList,
                                                        linhaFormList.idRendaFalta),
                                                            valorPergunta(values,
                                                                linhaFormList.idRendaFalta))
                                            }
                                            tooltip={LABEL.cliqueParaAtribuirAutomaticamenteRetiradaMensal}
                                            onClick={() => {
                                                values.retiradaMensalDepoisAposentarCliente =
                                                    valorPergunta(values,
                                                        linhaFormList.idRendaFalta)
                                            }}
                                        />
                                    </GridItem12>
                                :
                                    ''
                        }
                    </GridContainer>
                    {/*})}*/}

                    <div
                        className='mt-5'
                    />
                </CardGridEntradaDadosHeaderBody>

                <CardGridEntradaDadosHeaderBody
                    title={LABEL.relatoriosGraficos}
                >
                    <GridContainer
                        className='mb-2'
                    >
                        {!popup && (
                            <GridItem3xs6>
                                <CustomizedDialogsPopupDiagnosticoAposentadoriaIndependenciaFinanceira
                                    values={values}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    setFieldValue={setFieldValue}
                                    estudo={estudo}
                                />
                            </GridItem3xs6>
                        )}

                        {!popup && (
                            <GridItem3xs6>
                                <CustomizedDialogsPopupEvolucaoReservaFinanceira
                                    values={values}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    estudo={estudo}
                                />
                            </GridItem3xs6>
                        )}

                        <GridItem3xs6>
                            <CustomizedDialogsPopupComparacaoCenarios
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                            />
                        </GridItem3xs6>

                        {values.jsonComparacaoEstudos.estudos.length > 1 && (
                            <GridItem3xs6>
                                <CustomizedDialogsPopupComparacaoEstudos
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    estudo={estudo}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    jsonConfiguracao={vars.jsonConfiguracao}
                                    jsonPagina={vars.jsonPagina}
                                    jsonUsuario={vars.jsonUsuario}
                                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                />
                            </GridItem3xs6>
                        )}
                    </GridContainer>

                    <GridContainer>
                        <GridItem8
                            className={'mt-6'}
                        >
                            {LABEL.anosExibicaoRelatorioEvolucaoReservaFinanceira}
                        </GridItem8>

                        <GridItem2>
                            <TextValidatorNumber
                                name="anosExibicaoRelatorioEvolucaoReservaFinanceira"
                                label={LABEL.anoAnos}
                                value={values.anosExibicaoRelatorioEvolucaoReservaFinanceira || ''}
                                onChange={handleChange}
                                numMin={NUMMIN.anosExibicaoRelatorioEvolucaoReservaFinanceira}
                                numMax={NUMMAX.anosExibicaoRelatorioEvolucaoReservaFinanceira}
                            />
                        </GridItem2>
                    </GridContainer>
                </CardGridEntradaDadosHeaderBody>

                <SimulacaoFinanceiraFormAporteRetiradaMensal
                    values={values}
                    handleChange={handleChange}
                />

                <SimulacaoFinanceiraFormAporteRetiradaAnual
                    values={values}
                    handleChange={handleChange}
                />
            </CardGridEntradaDados>
        </GridItemHipotesesFinanceiras>
        //)
    )
}

export default SimulacaoFinanceiraFormHipotesesFinanceiras